import React from 'react'

export default function CheckIcon() {
  return (
    <svg className='cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
    <path d="M10.1936 1.45386L4.15867 8.74884L1.57227 5.83084" stroke="#31C65B" stroke-width="1.32636" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  )
}
